<body>
    <router-outlet></router-outlet>
    <app-top-scroller></app-top-scroller>
</body>